import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'core-poi-names',
  templateUrl: './poi-names.component.html',
})
export class PoiNamesComponent {
  @ViewChild('strings', { static: true, read: ElementRef }) s: ElementRef;
}
